import { render, staticRenderFns } from "./AggregationGrid.vue?vue&type=template&id=67c4aa92&scoped=true&"
import script from "./AggregationGrid.vue?vue&type=script&lang=js&"
export * from "./AggregationGrid.vue?vue&type=script&lang=js&"
import style0 from "./AggregationGrid.vue?vue&type=style&index=0&id=67c4aa92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c4aa92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
